import { Avatar, Grid, styled } from "@mui/material";
import { types } from "api";
import { getInitials } from "helpers/authValidation";

const PREFIX = "ProfileLayout";

const classes = {
	avatarWrapper: `${PREFIX}-avatarWrapper`,
	avatar: `${PREFIX}-avatar`,
	children: `${PREFIX}-children`,
};

const Root = styled(Grid)(({ theme }) => ({
	padding: theme.spacing(4),
	textAlign: "center",
	color: theme.palette.text.secondary,
	minHeight: "20vh",
	minWidth: "100%",
	alignItems: "center",
	flexWrap: "nowrap",

	[theme.breakpoints.down("sm")]: {
		flexDirection: "column",
	},
	[theme.breakpoints.up("md")]: {
		flexDirection: "row",
	},

	[`& .${classes.avatar}`]: {
		color: theme.palette.primary.contrastText,
		backgroundColor: theme.palette.secondary.main,
		width: theme.spacing(35),
		height: theme.spacing(35),
		[theme.breakpoints.up("xs")]: {
			width: theme.spacing(15),
			height: theme.spacing(15),
			fontSize: "4rem",
		},
		[theme.breakpoints.up("md")]: {
			width: theme.spacing(25),
			height: theme.spacing(25),
			fontSize: "6rem",
		},
		[theme.breakpoints.up("lg")]: {
			width: theme.spacing(35),
			height: theme.spacing(35),
			fontSize: "8rem",
		},
	},

	[`& .${classes.children}`]: {
		width: "100%",
		justifyContent: "space-between",
	},
}));

export interface ProfileLayoutProps {
	user: types.User | null;

	children: React.ReactNode;
}

export const ProfileLayout = ({
	children,
	user,
}: ProfileLayoutProps): JSX.Element => {
	return (
		<Root container spacing={2}>
			<Grid item>
				<Avatar className={classes.avatar}>
					{user && getInitials(user.firstName, user.lastName)}
				</Avatar>
			</Grid>

			<Grid item className={classes.children}>
				{children}
			</Grid>
		</Root>
	);
};
